import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { TROUBLESHOOTING_CRUD_ACTION_CREATORS } from '../actions/troubleshooting_actions';
import FetchUtils from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const troubleshootingRestCrudThunksForBuyer = new RestCrudThunks(
	'work_order_troubleshooting',
	'work_order_troubleshooting',
	'troubleshotting',
	'troubleshotting',
	TROUBLESHOOTING_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'troubleshooting/'
);

export const troubleshootingRestCrudThunksForSupplier = new RestCrudThunks(
	'work_order_troubleshooting',
	'work_order_troubleshooting',
	'troubleshotting',
	'troubleshotting',
	TROUBLESHOOTING_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'troubleshooting/'
);

const fetchTroubleshootingHydrated =
	(roleType) =>
	(
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		// if pagination present, transform into limit/offset format and add to query params
		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			params = {
				...params,
				...paginationQuery,
			};
		}

		// if sorting present, fix order naming and add to query params
		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			params = {
				...params,
				...sortingQuery,
			};
		}

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(TROUBLESHOOTING_CRUD_ACTION_CREATORS.fetchStart());

				const suffixUrl = '/troubleshooting/work_order_troubleshooting_hydrated';
				fetchUtils
					.get(
						getBackendUri() + `/api/v1/${roleType}` + suffixUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(TROUBLESHOOTING_CRUD_ACTION_CREATORS.fetchError(d.message, ''));
							reject(d.message);
						} else {
							dispatch(
								TROUBLESHOOTING_CRUD_ACTION_CREATORS.fetchSuccess(
									d.data,
									d.count,
									targetCollectionName,
									{
										...pagination,
										total: d.count,
									},
									sorting,
									filters,
									addToTargetCollection
								)
							);
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(TROUBLESHOOTING_CRUD_ACTION_CREATORS.fetchError(d.message, ''));
						reject(d.message);
					});
			});
		};
	};

export const fetchTroubleshootingHydratedForBuyer = fetchTroubleshootingHydrated(ROLE_TYPES.BUYER);
export const fetchTroubleshootingHydratedForSupplier = fetchTroubleshootingHydrated(
	ROLE_TYPES.SUPPLIER
);
